import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useCookies } from "react-cookie";
import { COOKIESPREFIX } from "../../../config";
import { validateEmail } from "../../../utils/util";
import { merchantLoginWithPassword } from "../../../services/users";
import { deleteEventParticipation, fetchEventScanCounts, importEventParticipations, merchantAddRemarks, merchantChangeParticipationStatus, merchantFetchParticipationWithUserData, wechatDepositRefund } from '../../../services/events';
import PageSelector from '../../../components/PageSelector';
import LoadingPage from "../../../components/Loading";
import DropdownMenu from '../components/Dropdown'
import { utils, writeFile } from 'xlsx';
import SearchSvg from '../../../svgs/SearchSvg'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);


const options = {
    plugins: {
        datalabels: {
            color: 'black', // Text color
            formatter: (value, context) => {
                // Display value or percentage
                const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                const percentage = ((value / total) * 100).toFixed(2) + '%';
                return percentage;
            },
            // Further styling options like anchor, align, offset etc.
        },
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Pie Chart'
        }
    },
};

function Page(props) {
    const { id: eventId } = useParams();

    const [isloading, setisloading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const limit = parseInt(searchParams.get('limit')) || 10
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterLastname = searchParams.get('lastname')
    const filterFirstname = searchParams.get('firstname')
    const filterEmail = searchParams.get('email')
    const filterRemark1 = searchParams.get('remark1')
    const filterType = searchParams.get('type') || '全部'
    const filterSession = searchParams.get('session') || 'null'

    //
    const handleSearchLastname = (e) => { setSearchParams({ page: 1, lastname: e.target.value }) }
    const handleSearchFirstname = (e) => { setSearchParams({ page: 1, firstname: e.target.value }) }
    const handleSearchEmail = (e) => { setSearchParams({ page: 1, email: e.target.value }) }
    const handleSearchRemark1 = (e) => { setSearchParams({ page: 1, remark1: e.target.value }) }
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, 1000 * 30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        // formatDataForChart()
        const filter = { eventId }
        const userFilter = {}
        if (filterType === '待批准') {
            filter.status = 'PENDING'
        } else if (filterType === '已拒絕') {
            filter.status = 'REJECTED'
        } else if (filterType === '已核准') {
            filter.status = 'APPROVED'
        }
        //'待批准','已核准','已拒絕'
        if (filterLastname) userFilter['user.data.lastname'] = { "$regex": filterLastname, "$options": 'i' }
        if (filterFirstname) userFilter['user.data.firstname'] = { "$regex": filterFirstname, "$options": 'i' }
        if (filterEmail) userFilter['user.email'] = { "$regex": filterEmail, "$options": 'i' }
        if (filterRemark1) filter['remarks.remark1'] = { "$regex": filterRemark1, "$options": 'i' }
        if (filterSession !== 'null' && filterSession !== null) filter[`data.isAttendEvent${Number(filterSession) + 1}`] = true
        const res = await merchantFetchParticipationWithUserData(props.token.token, filter, { limit, skip: limit * (page - 1), sort: { _id: -1 } }, userFilter)
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item, index) {
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }
    function selectSession(item, index) {
        searchParams.delete('session')
        searchParams.set('session', item === '全部' ? 'null' : Number(item.split('.')[0]) - 1)
        setSearchParams(searchParams)
    }

    const handleApprove = (item, status) => async () => {
        setisloading(true)
        let result = await merchantChangeParticipationStatus(props.token?.token, item?.user?._id, eventId, status)
        if (result?.errno) {
            alert(`${result?.message || 'error'}`)
        } else {
            await fetchData()
        }
        setisloading(false)
    }
    const handleApproveAll = async () => {
        let hasError = false
        setisloading(true)
        for (let item of data) {
            if (item.isSelected && item.status !== 'APPROVED') {
                let result = await merchantChangeParticipationStatus(props.token?.token, item?.user?._id, eventId, 'APPROVED')
                if (result?.errno) {
                    console.log(`${result?.message || 'error'}`)
                    hasError = `${result?.message || 'error'}`
                }
            }
        }
        await fetchData()
        setisloading(false)
        if (hasError)
            alert(hasError)
    }
    const handleRejectAll = async () => {
        let hasError = false
        setisloading(true)
        for (let item of data) {
            if (item.isSelected && item.status !== 'REJECTED') {
                let result = await merchantChangeParticipationStatus(props.token?.token, item?.user?._id, eventId, 'REJECTED')
                if (result?.errno) {
                    console.log(`${result?.message || 'error'}`)
                    hasError = `${result?.message || 'error'}`
                }
            }
        }
        await fetchData()
        setisloading(false)
        if (hasError)
            alert(hasError)
    }


    // 'PENDING':"PENDING",
    // 'REJECTED':'REJECTED',
    // 'APPROVED':"APPROVED"

    const handleSaveImage = (imageUrl) => {
        const link = document.createElement('a');
        link.target = "_blank"
        link.href = imageUrl;
        link.download = 'qrcode.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [isAddingRemarks, setisAddingRemarks] = useState(null)
    const handleAddRemarks = async () => {
        setisloading(true)
        let result = await merchantAddRemarks(props.token?.token, isAddingRemarks?.user?._id, eventId, isAddingRemarks.remarks)
        if (result?.errno) {
            alert(`${result?.message || 'error'}`)
        } else {
            setisAddingRemarks(null)
            await fetchData()
        }
        setisloading(false)
    }

    const handleCancelRemarks = () => {
        setisAddingRemarks(null)
    }

    const registrationForm = props.data?.registrationForm || {}
    const handleDownload = async () => {
        setisloading(true)
        const res = await merchantFetchParticipationWithUserData(props.token.token, { eventId }, { limit: 99999, sort: { _id: -1 } }, {})
        if (res.errno || !res.result) {
            alert('Download Error')
        } else {
            let data = res.result
            console.log(data)

            const array = [
                [
                    '電郵地址(Email)',
                    '姓(Surname)',
                    '名(Firstname)',
                    ...registrationForm?.enableAge ? ['年齡(Age)'] : [],
                    ...registrationForm?.enableMobile ? ['手機號(Mobile)'] : [],
                    ...registrationForm?.enableWechat ? ['微信號(Wechat ID)'] : [],
                    ...registrationForm?.enableHighestDegree ? ['您的最高學位(Your highest degree)'] : [],
                    ...registrationForm?.enableSchoolAndMajor ? ['畢業學校及專業(School and major)'] : [],
                    ...registrationForm?.enableWorkExperience ? ['您的工作經驗(Your work experience)'] : [],
                    ...registrationForm?.enableCurrentEmployer ? ['目前工作單位名稱(Current employer)'] : [],
                    ...registrationForm?.enablePosition ? ['職位(position)'] : [],
                    ...registrationForm?.enableHongKongVisa ? ['您的香港簽證類型(Your Hong Kong visa)'] : [],
                    ...registrationForm?.enableGraduationTime ? ['畢業時間(Graduation time)'] : [],
                    ...registrationForm?.enableExtraQuestion1 ? [registrationForm?.extraQuestion1] : [],
                    ...registrationForm?.enableExtraQuestion2 ? [registrationForm?.extraQuestion2] : [],
                    ...registrationForm?.enableExtraQuestion3 ? [registrationForm?.extraQuestion3] : [],
                    ...registrationForm?.enableExtraQuestion4 ? [registrationForm?.extraQuestion4] : [],
                    ...registrationForm?.enableExtraQuestion5 ? [registrationForm?.extraQuestion5] : [],
                    ...registrationForm?.enableExtraMCQuestion1 ? [registrationForm?.extraMCQuestion1] : [],
                    ...registrationForm?.enableExtraMCQuestion2 ? [registrationForm?.extraMCQuestion2] : [],
                    ...registrationForm?.enableExtraMCQuestion3 ? [registrationForm?.extraMCQuestion3] : [],
                    ...registrationForm?.enableExtraMCQuestion4 ? [registrationForm?.extraMCQuestion4] : [],
                    ...registrationForm?.enableExtraMCQuestion5 ? [registrationForm?.extraMCQuestion5] : [],
                    ...registrationForm?.enableExtraShortQuestion1 ? [registrationForm?.extraShortQuestion1] : [],
                    ...registrationForm?.enableExtraShortQuestion2 ? [registrationForm?.extraShortQuestion2] : [],
                    ...registrationForm?.enableExtraShortQuestion3 ? [registrationForm?.extraShortQuestion3] : [],
                    ...registrationForm?.enableExtraShortQuestion4 ? [registrationForm?.extraShortQuestion4] : [],
                    ...registrationForm?.enableExtraShortQuestion5 ? [registrationForm?.extraShortQuestion5] : [],
                ],
            ];
            if (registrationForm.enableAttendanceSession) {
                for (let i = 0; i < registrationForm.attendanceSessions.length; i++)
                    if (registrationForm.attendanceSessions[i]) {
                        array[0].push(`環節${i + 1}:${registrationForm.attendanceSessions[i].name}`)
                        array[0].push(`環節${i + 1}簽到狀態`)
                    }
            }
            if (registrationForm?.enableUploadCV)
                array[0].push('上傳履歷(Upload CV)');
            array[0].push('審批狀態', '出席狀態', '備註 1', '備註 2', '下載二維碼');

            for (let item of data) {
                let row = [
                    item?.user?.email || '',
                    item?.user?.data?.lastname || '',
                    item?.user?.data?.firstname || '',
                    ...registrationForm?.enableAge ? [item?.user?.data?.age || item?.data?.age || ''] : [],
                    ...registrationForm?.enableMobile ? [item?.user?.data?.businessProfile?.mobile || item?.data?.mobile || ''] : [],
                    ...registrationForm?.enableWechat ? [item?.user?.data?.businessProfile?.wechat || item?.data?.wechat || ''] : [],
                    ...registrationForm?.enableHighestDegree ? [item?.user?.data?.degree || item?.data?.degree || ''] : [],
                    ...registrationForm?.enableSchoolAndMajor ? [item?.user?.data?.school || item?.data?.school || ''] : [],
                    ...registrationForm?.enableWorkExperience ? [item?.user?.data?.workEx || item?.data?.workEx || ''] : [],
                    ...registrationForm?.enableCurrentEmployer ? [item?.user?.data?.company || item?.data?.company || ''] : [],
                    ...registrationForm?.enablePosition ? [item?.user?.data?.position || item?.data?.position || ''] : [],
                    ...registrationForm?.enableHongKongVisa ? [item?.user?.data?.visa || item?.data?.visa || ''] : [],
                    ...registrationForm?.enableGraduationTime ? [item?.user?.data?.graduationTime || item?.data?.graduationTime || ''] : [],
                    ...registrationForm?.enableExtraQuestion1 ? [item?.data?.extraQuestion1 || ''] : [],
                    ...registrationForm?.enableExtraQuestion2 ? [item?.data?.extraQuestion2 || ''] : [],
                    ...registrationForm?.enableExtraQuestion3 ? [item?.data?.extraQuestion3 || ''] : [],
                    ...registrationForm?.enableExtraQuestion4 ? [item?.data?.extraQuestion4 || ''] : [],
                    ...registrationForm?.enableExtraQuestion5 ? [item?.data?.extraQuestion5 || ''] : [],
                    ...registrationForm?.enableExtraMCQuestion1 ? [item?.data?.extraMCQuestion1 || ''] : [],
                    ...registrationForm?.enableExtraMCQuestion2 ? [item?.data?.extraMCQuestion2 || ''] : [],
                    ...registrationForm?.enableExtraMCQuestion3 ? [item?.data?.extraMCQuestion3 || ''] : [],
                    ...registrationForm?.enableExtraMCQuestion4 ? [item?.data?.extraMCQuestion4 || ''] : [],
                    ...registrationForm?.enableExtraMCQuestion5 ? [item?.data?.extraMCQuestion5 || ''] : [],
                    ...registrationForm?.enableExtraShortQuestion1 ? [item?.data?.extraShortQuestion1 || ''] : [],
                    ...registrationForm?.enableExtraShortQuestion2 ? [item?.data?.extraShortQuestion2 || ''] : [],
                    ...registrationForm?.enableExtraShortQuestion3 ? [item?.data?.extraShortQuestion3 || ''] : [],
                    ...registrationForm?.enableExtraShortQuestion4 ? [item?.data?.extraShortQuestion4 || ''] : [],
                    ...registrationForm?.enableExtraShortQuestion5 ? [item?.data?.extraShortQuestion5 || ''] : [],
                ]
                if (registrationForm?.enableAttendanceSession && registrationForm?.attendanceSessions) {
                    for (let i = 0; i < registrationForm.attendanceSessions.length; i++) {
                        if (registrationForm.attendanceSessions[i]) {
                            row.push(item?.data?.[`isAttendEvent${i + 1}`] ? '出席' : '不出席')
                            row.push(item?.attendanceSessions?.[i]?.signInTime ? '已簽到' : '未簽到')
                        }
                    }
                }
                if (registrationForm?.enableUploadCV) {
                    row.push(item?.user?.data?.cv || item?.data?.cv || '')
                }
                row.push(
                    item?.status === 'APPROVED' ? '已核准' : item?.status === 'REJECTED' ? '已拒絕' : '待批准',
                    item?.signInTime ? '已參會' : '-',
                    item?.remarks?.remark1 || '',
                    item?.remarks?.remark2 || '',
                    item?.s3url || ''
                )
                array.push(row)
            }



            const ws = utils.aoa_to_sheet(array);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, '參與者訊息');
            writeFile(wb, `${props.data?.name}參與者訊息.xlsx`);


        }
        setisloading(false)
    }
    const handleDownloadScanRecords = async () => {
        setisloading(true)
        const res = await fetchEventScanCounts(props.token.token, { eventId }, { limit: 99999 }, {})
        if (res.errno || !res.result) {
            alert('Download Error')
        } else {
            let data = res.result
            console.log(data)

            const array = [
                ['Total:', data.length || 0],
                [''],
                ['userId', 'time', 'message'],
            ];


            for (let item of data) {
                array.push([
                    item.userId,
                    item.createDate ? new Date(item.createDate).toLocaleString() : '',
                    item?.message || ''
                ])
            }


            const ws = utils.aoa_to_sheet(array);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, '入場掃描記錄');
            writeFile(wb, `${props.data?.name}入場掃描記錄.xlsx`);


        }
        setisloading(false)
    }
    const [isUploading, setIsUploading] = useState(false)
    const handleStartUpload = () => { setIsUploading(true) }
    const OpenNewTab = (url) => () => {
        const newTab = window.open(url, '_blank');
        if (newTab) {
            newTab.focus();
        } else {
            alert('請允許彈出窗口');
        }
    }
    const handleUpload = (e) => {
        e.preventDefault();

        var files = e.target.files, f = files[0];
        var reader = new FileReader();
        reader.onload = function (e) {
            var data = e.target.result;
            let readedData = XLSX.read(data, { type: 'binary' });
            const wsname = readedData.SheetNames[0];
            const ws = readedData.Sheets[wsname];

            /* Convert array to json*/
            const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
            if (dataParse.length > 9999) {
                alert('m- Error Data too large');
                return
            }
            console.log(dataParse)
            //check header			
            if (!dataParse[0] || dataParse[0].length !== 11) {
                alert('Invalid format - (invalid header length)');
                return
            }
            //check missing column data
            for (let [i] of dataParse.entries()) {
                if (i === 0) continue;
                let firstname = dataParse[i][1] || dataParse[i][3] || '';;
                let lastname = dataParse[i][2] || '';
                let email = dataParse[i][5] || '';
                if (!firstname) {
                    alert(`第${i}行中的中文名 Chinese Firstname 不能為空`);
                    return
                }
                // if(!lastname){
                //     alert(`第${i}行中的中文姓氏 Chinese Lastname 不能為空`);
                //     return
                // }
                if (!validateEmail(email)) {
                    alert(`第${i}行中的電郵地址 Email 格式錯誤 , EMAIL: ${email}`);
                    return
                }
            }

            let data_ = []
            for (let [i] of dataParse.entries())
                if (i > 0) {
                    let firstname = dataParse[i][1] || dataParse[i][3] || '';;
                    let lastname = dataParse[i][2] || '';
                    let englishName = dataParse[i][3] || '';
                    let mobile = dataParse[i][4] || '';
                    let email = dataParse[i][5] || '';
                    let isAttendEvent1 = dataParse[i][6] === 'Y' || dataParse[i][6] === '是';
                    let isAttendEvent2 = dataParse[i][7] === 'Y' || dataParse[i][7] === '是';
                    let isAttendEvent3 = dataParse[i][8] === 'Y' || dataParse[i][8] === '是';
                    let isAttendEvent4 = dataParse[i][9] === 'Y' || dataParse[i][9] === '是';
                    let isAttendEvent5 = dataParse[i][10] === 'Y' || dataParse[i][10] === '是';
                    data_.push({
                        firstname,
                        lastname,
                        englishName,
                        mobile,
                        email,
                        isAttendEvent1,
                        isAttendEvent2,
                        isAttendEvent3,
                        isAttendEvent4,
                        isAttendEvent5,
                    })
                }
            console.log(data_)
            setIsUploading(data_)
        };
        reader.readAsArrayBuffer(f)
    }
    const handleConfirmUpload = async () => {
        console.log(isUploading)
        if (!isUploading || !Array.isArray(isUploading) || isUploading.length === 0) {
            alert('請先選擇文件')
            return
        }
        let result = await importEventParticipations(props.token?.token, eventId, isUploading)
        setisloading(true)
        if (result?.errno) {
            alert(`${result?.message || 'error'}`)
        } else {
            alert('上傳成功')
            setIsUploading(false)
            await fetchData()
        }
        setisloading(false)
    }

    const [isRefundingDeposit, setIsRefundingDeposit] = useState(null)
    const handleConfirmRefundDeposit = async () => {
        setisloading(true)
        let result = await wechatDepositRefund(props.token?.token, isRefundingDeposit?._id)
        if (result?.errno) {
            alert(`${result?.message || 'error'}`)
        } else {
            alert('訂金退款成功')
            setIsRefundingDeposit(null)
            await fetchData()
        }
        setisloading(false)
    }

    const handleDeleteSelected = async () => {
        if (!window.confirm('確定要刪除選中的參與者嗎？')) return
        let hasError = false
        setisloading(true)
        for (let item of data) {
            if (item.isSelected) {
                let result = await deleteEventParticipation(props.token?.token, item?._id)
                if (result?.errno) {
                    console.log(`${result?.message || 'error'}`)
                    hasError = `${result?.message || 'error'}`
                }
            }
        }
        setisloading(false)
        await fetchData()
        if (hasError)
            alert(hasError)
    }

    const [statisticsData, setStatisticsData] = useState(null)
    const handleShowStatistics = async () => {
        setisloading(true)
        const res = await merchantFetchParticipationWithUserData(props.token.token, { eventId }, { limit: 99999, sort: { _id: -1 } }, {})
        if (res.errno || !res.result) {
            alert('Download Error')
        } else {
            let data = res.result

            //學歷背景,工作經驗,來港方式
            let dict = {
                '學歷背景': {},
                '工作經驗': {},
                '來港方式': {}
            }



            for (let item of data) {
                let degree = item?.data?.degree || '未填寫'
                let workEx = item?.data?.workEx || '未填寫'
                let visa = item?.data?.visa || '未填寫'
                dict['學歷背景'][degree.includes('其他 Other') ? '其他 Other' : degree] = (dict['學歷背景'][degree.includes('其他 Other') ? '其他 Other' : degree] || 0) + 1
                dict['工作經驗'][workEx] = (dict['工作經驗'][workEx] || 0) + 1
                dict['來港方式'][visa] = (dict['來港方式'][visa] || 0) + 1

            }
            setStatisticsData(dict)
        }
        setisloading(false)
    }

    function generateRamdomColor() {
        const letters = '0123456789ABCDEF';
        let color = '';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    function getTotal(category) {
        let keys = []
        if (category === '學歷背景') {
            keys = ['學士 Bachelor', '碩士 Master', '博士 Doctor', '其他 Other']
        } else if (category === '工作經驗') {
            keys = ['應屆畢業生 Fresh graduates',
                '1-2年工作經驗 working experience',
                '3-5年工作經驗 working experience',
                '6-9年工作經驗 working experience',
                '10年及以上工作經驗 working experience']
        } else if (category === '來港方式') {
            keys = [
                '香港本地永久居民 Hong Kong Permanent Resident',
                '優秀人才入境計劃 Quality Migrant AdmissionScheme',
                '輸入內地人才計劃 Admission Scheme for Mainland Talents and Professionals',
                '一般就業政策（外籍專才）General Employment Policy',
                '高端人才通行證計劃 Top Talent Pass Scheme',
                '科技人才入境計劃 Technology Talent Admission Scheme',
                '在讀學生 Student Visa',
                '非本地畢業生留港/回港計劃 IANG Visa',
                '澳門居民 Macao Resident',
                '內地居民 Mainland Resident',
                '其他國家身份 Resident of other countries'
            ]
        }

        let total = 0
        for (let key of keys) {
            total += statisticsData?.[category]?.[key] || 0
        }
        return total
    }


    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden px-[16px]">

            <div className="w-full flex flex-row gap-[8px] flex-wrap items-center justify-start mb-[12px]">
                {/* <input onChange={handleSearchLastname} placeholder="按姓氏搜尋" className="p-[4px] rounded-[4px]"/>
                <input onChange={handleSearchFirstname} placeholder="按名字搜尋" className="p-[4px] rounded-[4px]"/>
                <input onChange={handleSearchEmail} placeholder="透過電子郵件搜尋" className="p-[4px] rounded-[4px]"/>
                <input onChange={handleSearchRemark1} placeholder="透過備註 1搜尋" className="p-[4px] rounded-[4px]"/> */}
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchEmail} placeholder="電子郵件搜尋" className="bg-[transparent] w-[130px] border-none text-[12px]" />
                </div>
                <div className="z-[2] flex flex-row gap-[16px] items-center justify-start]">
                    <div className="text-[#6E604C] ml-[16px]">Filter By </div>
                    <DropdownMenu minWidth={120} value={filterType} select={selectFilter} style={{ fontSize: 12 }} options={['全部', '待批准', '已核准', '已拒絕']} />
                </div>
                {registrationForm?.enableAttendanceSession && registrationForm?.attendanceSessions && registrationForm?.attendanceSessions.length > 0 &&
                    <div className="z-[2] flex flex-row gap-[16px] items-center justify-start]">
                        <div className="text-[#6E604C] ml-[16px]">環節</div>
                        <DropdownMenu minWidth={150} value={filterSession === 'null' ? '全部' : (registrationForm?.attendanceSessions?.[filterSession]?.name || '全部')} select={selectSession} style={{ fontSize: 12 }} options={['全部', ...registrationForm?.attendanceSessions?.map((s, i) => `${i + 1}.${s.name}`)]} />
                    </div>
                }
            </div>
            <div className="w-full flex flex-row gap-[8px] flex-wrap items-center justify-between mb-[6px]">
                <div className="flex flex-row flex-1 justify-end items-center" style={{ gap: 8 }}>
                    <div onClick={handleDeleteSelected} className="text-[10px] cursor-pointer p-[4px] rounded-[4px] text-[white] w-[140px] text-center" style={{ background: 'linear-gradient(180deg, #8C706B 0%, rgba(140, 112, 107, 0.2) 100%)' }}>刪除參與者</div>
                    <div onClick={handleApproveAll} className="text-[10px] cursor-pointer p-[4px] rounded-[4px] text-[white] w-[140px] text-center" style={{ background: 'linear-gradient(180deg, #0F737E 0%, rgba(15, 115, 126, 0.2) 100%)' }}>核准已選擇參與者</div>
                    <div onClick={handleRejectAll} className="text-[10px] cursor-pointer p-[4px] rounded-[4px] text-[white] w-[140px] text-center" style={{ background: 'linear-gradient(180deg, #8C706B 0%, rgba(140, 112, 107, 0.2) 100%)' }}>拒絕已選擇</div>
                    <div style={{ height: 35, width: 1, backgroundColor: 'black' }} />
                    <div onClick={handleStartUpload} className="text-[10px] cursor-pointer text-[white] p-[4px] rounded-[4px] px-[16px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>上傳名單</div>
                    <div onClick={handleDownload} className="text-[10px] cursor-pointer text-[white] p-[4px] rounded-[4px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>下載所有參與者訊息</div>
                    <div onClick={handleDownloadScanRecords} className="text-[10px] cursor-pointer text-[white] p-[4px] rounded-[4px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>下載入場記錄</div>
                    <div onClick={handleShowStatistics} className="text-[10px] cursor-pointer text-[white] p-[4px] rounded-[4px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>統計分析</div>
                </div>
            </div>
            <div className="flex-1 w-full flex flex-col py-[16px]" style={{ overflowY: 'auto' }}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center w-full text-[10px] text-[#6E604C] font-[700] pb-[8px]" style={{ borderBottom: '2px solid #6E604C' }}>
                    <div className="w-[24px] h-[24px] flex flex-row items-center">
                        <input type="checkbox" checked={data?.every(p => p.isSelected)} onChange={(e) => {
                            let isAllSelected = data?.every(p => p.isSelected)
                            let d = [...data];
                            for (let i of data) {
                                i.isSelected = isAllSelected ? false : true
                            }
                            setData(d)
                        }} />
                    </div>
                    <div className="flex-[2]">電郵地址(Email)</div>
                    <div className="flex-1">姓(Surname)</div>
                    <div className="flex-1">名(Firstname)</div>
                    {registrationForm?.enableAge && <div className="flex-1">年齡(Age)</div>}
                    {registrationForm?.enableMobile && <div className="flex-1">手機號(Mobile)</div>}
                    {registrationForm?.enableWechat && <div className="flex-1">微信號(Wechat ID)</div>}
                    {/* {registrationForm?.enableHighestDegree && <div className="flex-1">您的最高學位(Your highest degree)</div>}
                    {registrationForm?.enableSchoolAndMajor && <div className="flex-1">畢業學校及專業(School and major)</div>}
                    {registrationForm?.enableWorkExperience && <div className="flex-1">您的工作經驗(Your work experience)</div>} */}
                    {registrationForm?.enableCurrentEmployer && <div className="flex-1">目前工作單位名稱(Current employer)</div>}
                    {registrationForm?.enablePosition && <div className="flex-1">職位(position)</div>}
                    {/* {registrationForm?.enableHongKongVisa && <div className="flex-1">您的香港簽證類型(Your Hong Kong visa)</div>} */}
                    {registrationForm?.enableExtraQuestion1 && <div className="flex-1">{registrationForm?.extraQuestion1}</div>}
                    {registrationForm?.enableExtraQuestion2 && <div className="flex-1">{registrationForm?.extraQuestion2}</div>}
                    {registrationForm?.enableExtraQuestion3 && <div className="flex-1">{registrationForm?.extraQuestion3}</div>}
                    {registrationForm?.enableExtraQuestion4 && <div className="flex-1">{registrationForm?.extraQuestion4}</div>}
                    {registrationForm?.enableExtraQuestion5 && <div className="flex-1">{registrationForm?.extraQuestion5}</div>}
                    {registrationForm?.enableExtraMCQuestion1 && <div className="flex-1">{registrationForm?.extraMCQuestion1}</div>}
                    {registrationForm?.enableExtraMCQuestion2 && <div className="flex-1">{registrationForm?.extraMCQuestion2}</div>}
                    {registrationForm?.enableExtraMCQuestion3 && <div className="flex-1">{registrationForm?.extraMCQuestion3}</div>}
                    {registrationForm?.enableExtraMCQuestion4 && <div className="flex-1">{registrationForm?.extraMCQuestion4}</div>}
                    {registrationForm?.enableExtraMCQuestion5 && <div className="flex-1">{registrationForm?.extraMCQuestion5}</div>}
                    {registrationForm?.enableExtraShortQuestion1 && <div className="flex-1">{registrationForm?.extraShortQuestion1}</div>}
                    {registrationForm?.enableExtraShortQuestion2 && <div className="flex-1">{registrationForm?.extraShortQuestion2}</div>}
                    {registrationForm?.enableExtraShortQuestion3 && <div className="flex-1">{registrationForm?.extraShortQuestion3}</div>}
                    {registrationForm?.enableExtraShortQuestion4 && <div className="flex-1">{registrationForm?.extraShortQuestion4}</div>}
                    {registrationForm?.enableExtraShortQuestion5 && <div className="flex-1">{registrationForm?.extraShortQuestion5}</div>}
                    {/* {registrationForm?.enableUploadCV && <div className="flex-1">上傳履歷(Upload CV)</div>} */}


                    {/* <div className="flex-1">英文名(English Name)</div> */}
                    <div className="flex-[1]">審批狀態</div>
                    <div className="flex-[1]">
                        {(filterSession === 'null' || filterSession === null) ?
                            '' :
                            `環節${Number(filterSession) + 1}`
                        }
                        出席狀態
                    </div>
                    {props.data?.isWechatDeposit && <div className="flex-[1]">
                        微信支付狀態
                    </div>}
                    <div className="flex-[1]">備註 1</div>
                    <div className="flex-[1]">備註 2</div>
                    <div className="w-[48px] h-[24px]"></div>
                    <div className="flex-[1]">報名時間</div>
                    <div className="flex-1">下載二維碼</div>
                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item, index) =>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center w-full text-[10px] text-[black] font-[400] py-[8px]" style={{ borderBottom: '.5px solid #fff', backgroundColor: item.isSelected ? '#ccc' : 'transparent' }}>
                            <div className="w-[24px] h-[24px] flex flex-row items-center">
                                <input type="checkbox" checked={item.isSelected} onChange={(e) => {
                                    let d = [...data];
                                    for (let i of data) {
                                        if (i._id === item._id) i.isSelected = !i.isSelected
                                    }
                                    setData(d)
                                }} />
                            </div>
                            <div className="flex-[2]">{item?.user?.email || ''}</div>
                            <div className="flex-1">{item?.user?.data?.lastname || ''}</div>
                            <div className="flex-1">{item?.user?.data?.firstname || ''}</div>
                            {registrationForm?.enableAge && <div className="flex-1">{item?.user?.data?.age || item?.data?.age || ''}</div>}
                            {registrationForm?.enableMobile && <div className="flex-1">{item?.user?.data?.businessProfile?.mobile || item?.data?.mobile || ''}</div>}
                            {registrationForm?.enableWechat && <div className="flex-1">{item?.user?.data?.businessProfile?.wechat || item?.data?.wechat || ''}</div>}
                            {/* {registrationForm?.enableHighestDegree && <div className="flex-1">{item?.user?.data?.degree||item?.data?.degree||''}</div>}
                            {registrationForm?.enableSchoolAndMajor && <div className="flex-1">{item?.user?.data?.school||item?.data?.school||''}</div>}
                            {registrationForm?.enableWorkExperience && <div className="flex-1">{item?.user?.data?.workEx||item?.data?.workEx||''}</div>} */}
                            {registrationForm?.enableCurrentEmployer && <div className="flex-1">{item?.user?.data?.company || item?.data?.company || ''}</div>}
                            {registrationForm?.enablePosition && <div className="flex-1">{item?.user?.data?.position || item?.data?.position || ''}</div>}
                            {/* {registrationForm?.enableHongKongVisa && <div className="flex-1">{item?.user?.data?.visa||item?.data?.visa||''}</div>} */}
                            {registrationForm?.enableExtraQuestion1 && <div className="flex-1">{item?.data?.extraQuestion1 || ''}</div>}
                            {registrationForm?.enableExtraQuestion2 && <div className="flex-1">{item?.data?.extraQuestion2 || ''}</div>}
                            {registrationForm?.enableExtraQuestion3 && <div className="flex-1">{item?.data?.extraQuestion3 || ''}</div>}
                            {registrationForm?.enableExtraQuestion4 && <div className="flex-1">{item?.data?.extraQuestion4 || ''}</div>}
                            {registrationForm?.enableExtraQuestion5 && <div className="flex-1">{item?.data?.extraQuestion5 || ''}</div>}
                            {registrationForm?.enableExtraMCQuestion1 && <div className="flex-1">{item?.data?.extraMCQuestion1 || ''}</div>}
                            {registrationForm?.enableExtraMCQuestion2 && <div className="flex-1">{item?.data?.extraMCQuestion2 || ''}</div>}
                            {registrationForm?.enableExtraMCQuestion3 && <div className="flex-1">{item?.data?.extraMCQuestion3 || ''}</div>}
                            {registrationForm?.enableExtraMCQuestion4 && <div className="flex-1">{item?.data?.extraMCQuestion4 || ''}</div>}
                            {registrationForm?.enableExtraMCQuestion5 && <div className="flex-1">{item?.data?.extraMCQuestion5 || ''}</div>}
                            {registrationForm?.enableExtraShortQuestion1 && <div className="flex-1">{item?.data?.extraShortQuestion1 || ''}</div>}
                            {registrationForm?.enableExtraShortQuestion2 && <div className="flex-1">{item?.data?.extraShortQuestion2 || ''}</div>}
                            {registrationForm?.enableExtraShortQuestion3 && <div className="flex-1">{item?.data?.extraShortQuestion3 || ''}</div>}
                            {registrationForm?.enableExtraShortQuestion4 && <div className="flex-1">{item?.data?.extraShortQuestion4 || ''}</div>}
                            {registrationForm?.enableExtraShortQuestion5 && <div className="flex-1">{item?.data?.extraShortQuestion5 || ''}</div>}
                            {/* {registrationForm?.enableUploadCV && <div className="flex-1">
                                {item?.user?.data?.cv||item?.data?.cv?
                                    <div className="cursor-pointer" onClick={OpenNewTab(item?.user?.data?.cv||item?.data?.cv)}>
                                        <img src='/cv.png' className="w-[18px] h-[18px]" alt='cv icon'/>
                                    </div>
                                    :<div className="text-[#717171] text-[13px] font-[500] w-[60px] text-center py-[4px] rounded-[99px]">未上傳</div>
                                }
                            </div>} */}
                            {/* <div className="flex-1">{item?.user?.data?.englishName||''}</div> */}
                            <div className="flex-[1] flex flex-row justify-start items-center">{
                                item?.status === 'APPROVED' ? <div className="flex flex-row items-center gap-[8px]">
                                    已核准
                                    <div className="cursor-pointer" onClick={handleApprove(item, "PENDING")}><ReloadSvg /></div>
                                </div>
                                    : item?.status === 'REJECTED' ? <div className="flex flex-row items-center gap-[8px]">
                                        已拒絕
                                        <div className="cursor-pointer" onClick={handleApprove(item, "PENDING")}><ReloadSvg /></div>
                                    </div>
                                        : <div className="flex flex-row gap-[4px]">
                                            <div className='text-[#717171] text-[13px] font-[500] w-[50px] bg-white text-center py-[2px] rounded-[99px] cursor-pointer' onClick={handleApprove(item, "APPROVED")}>核准</div>
                                            <div className='text-[#A15454] border-[#A15454] border-[1px] text-[13px] font-[500] w-[50px] bg-[#CBCBCB] text-center py-[2px] rounded-[99px] cursor-pointer' onClick={handleApprove(item, "REJECTED")}>拒絕</div>
                                        </div>
                            }</div>
                            <div className="flex-[1]">{
                                (filterSession === 'null' || filterSession === null)
                                    ? (item?.signInTime ? "已參會" : '-')
                                    : (item?.attendanceSessions?.[filterSession]?.signInTime ? '已參會' : '-')
                            }</div>
                            {props.data?.isWechatDeposit &&
                                <div className="flex-[1]">{
                                    item?.isDepositRefunded
                                        ? <div>已退款 {item?.depositFee} {item?.isTdollar ? 'TDollar' : 'RMB'}</div>
                                        : (item?.depositFee || 0 > 0)
                                            ? <div>已支付 {item?.depositFee} {item?.isTdollar ? 'TDollar' : 'RMB'} <div className="cursor-pointer bg-[#aaa] rounded-[4px] text-white font-bold text-center" onClick={() => { setIsRefundingDeposit(item) }}>退款</div></div>
                                            : <div>未支付</div>
                                }</div>
                            }
                            <div className="flex-[1]">{item?.remarks?.remark1 || ''}</div>
                            <div className="flex-[1] flex flex-row">{item?.remarks?.remark2 || ''}
                            </div>
                            <div className="w-[48px]">
                                <div className="cursor-pointer" onClick={() => { setisAddingRemarks(JSON.parse(JSON.stringify(item))) }}>
                                    <img src='/edit.png' className="w-[18px] h-[18px]" alt='edit icon' />
                                </div>
                            </div>
                            <div className="flex-[1]">{new Date(item?.createDate).toLocaleString()}</div>
                            <div className="flex-1">
                                {item?.s3url ?
                                    <div className="cursor-pointer" onClick={() => { handleSaveImage(item?.s3url) }}>
                                        <img alt='qrcode' src='/qr-code.png' className="w-[24px] h-[24px]" />
                                    </div> : <div />}
                            </div>
                        </div>
                    )}
                    {data?.length === 0 && <div className="w-full h-full flex flex-col items-center justify-center">
                        <div className="text-[16px] text-[#6E604C] font-[700]">沒有參與者</div>
                        <div className="text-[12px] text-[#6E604C] font-[400]">請稍後再試</div>
                    </div>}
                </div>
            </div>

            <div className="flex flex-row w-full">
                <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />
                <DropdownMenu options={[10, 25, 50, 100, 500, 1000]} value={'每頁顯示: ' + limit} style={{ fontSize: 10 }} select={
                    (item, index) => {
                        searchParams.delete('limit')
                        searchParams.set('limit', item)
                        setSearchParams(searchParams)
                    }
                } dropup={true} />
            </div>
            {isAddingRemarks &&
                <div className="fixed top-0 bottom-0 left-0 right-0 bg-[#00000090] max-h-[100%] z-[100] flex justify-center items-center">
                    <div className="absolute top-0 bottom-0 left-0 right-0 z-[101]" />
                    <div className="max-w-[800px] max-h-[90%] w-[90%] p-[24px] bg-[white] rounded-[24px] flex flex-col jusitfy-start items-center z-[102]" style={{ overflowY: 'auto' }}>
                        <div className="text-black text-[24px] font-[700]">備註</div>
                        <div className="flex flex-row text-black text-[18px] font-[400] mt-[48px]">
                            備註 1:
                            <input value={isAddingRemarks?.remarks?.remark1 || ''} className='px-[8px] ml-[8px] rounded-[6px]' onChange={(e) => {
                                let d = { ...isAddingRemarks }
                                d.remarks = { ...d.remarks || {}, remark1: e.target.value }
                                setisAddingRemarks(d)
                            }} />
                        </div>
                        <div className="flex flex-row text-black text-[18px] font-[400] mt-[16px]">
                            備註 2:
                            <input value={isAddingRemarks?.remarks?.remark2 || ''} className='px-[8px] ml-[8px] rounded-[6px]' onChange={(e) => {
                                let d = { ...isAddingRemarks }
                                d.remarks = { ...d.remarks || {}, remark2: e.target.value }
                                setisAddingRemarks(d)
                            }} />
                        </div>

                        <div onClick={handleAddRemarks} className="cursor-pointer bg-[#0F737E] mt-[48px] text-[20px] font-[500] w-full flex items-center justify-center p-[12px] rounded-[99px] text-[white]">
                            確認
                        </div>
                        <div onClick={handleCancelRemarks} className="cursor-pointer text-[20px] font-[500] w-full flex items-center justify-center p-[12px] rounded-[99px] text-[black]">
                            取消
                        </div>
                    </div>
                </div>
            }
            {isUploading &&
                <div className="fixed top-0 bottom-0 left-0 right-0 bg-[#00000090] max-h-[100%] z-[100] flex justify-center items-center">
                    <div className="max-w-[800px] max-h-[90%] w-[90%] p-[24px] bg-[white] rounded-[24px] flex flex-col jusitfy-start items-center z-[50]">
                        <div className="text-black text-[24px] font-[700]">上傳名單</div>
                        <div className="text-black text-[16px] font-[400] mt-[16px]">請上傳Excel檔案，格式如下：</div>
                        <img src='/cms/uploadexample.png' className="w-[600px] h-[auto] mt-[16px]" alt='upload example' />
                        {/* <div>Example header: <b className="text-[12px] ml-[16px]">中文姓名 Chinese Name,英文姓名 English Name,電郵 Email</b></div> */}
                        <div className="flex flex-row">下載上傳文件樣本 : <div className="cursor-pointer text-[#0F737E] ml-[16px] font-[700]" onClick={OpenNewTab('/cms/upload_example.xlsx')}>upload_sample.xlsx</div></div>
                        <div className="flex flex-col items-center justify-center gap-[8px] mt-[24px]">
                            <input type="file" onChange={handleUpload} />
                        </div>

                        <div onClick={handleConfirmUpload} className="w-[400px] p-[8px] text-center rounded-[99px] flex flex-row items-center justify-center bg-[#0F737E] text-[white] cursor-pointer  mt-[24px]">
                            {Array.isArray(isUploading) && isUploading.length > 0 ? `確認上傳 ${isUploading.length} 位參與者` : '確認上傳'}
                        </div>
                        <div onClick={() => { setIsUploading(false) }} className="w-[400px] p-[8px] text-center rounded-[99px] flex flex-row items-center justify-center text-[#0F737E] bg-[white] cursor-pointer">
                            取消
                        </div>
                    </div>
                </div>
            }
            {isRefundingDeposit &&
                <div className="fixed top-0 bottom-0 left-0 right-0 bg-[#00000090] max-h-[100%] z-[100] flex justify-center items-center">
                    <div className="max-w-[400px] max-h-[90%] w-[90%] p-[24px] bg-[white] rounded-[24px] flex flex-col jusitfy-start items-center z-[50]">
                        <div className="text-black text-[20px] font-[700]">確認退款</div>
                        <div className="text-black text-[16px] font-[400] mt-[16px]">確定要為 {isRefundingDeposit?.user?.email} 退款 {isRefundingDeposit?.depositFee} {isRefundingDeposit?.isTdollar ? 'TDollar' : 'RMB'} 嗎？</div>


                        <div onClick={handleConfirmRefundDeposit} className="w-[300px] p-[8px] text-center rounded-[99px] flex flex-row items-center justify-center bg-[#0F737E] text-[white] cursor-pointer  mt-[24px]">
                            確認退款
                        </div>
                        <div onClick={() => { setIsRefundingDeposit(null) }} className="w-[300px] p-[8px] text-center rounded-[99px] flex flex-row items-center justify-center text-[#0F737E] bg-[white] cursor-pointer">
                            取消
                        </div>
                    </div>
                </div>
            }
            {statisticsData &&
                <div className="fixed top-0 bottom-0 left-0 right-0 bg-[#00000090] max-h-[100%] z-[100] flex justify-center items-center">
                    <div className="max-h-[90%] w-[90%] p-[24px] bg-[white] rounded-[24px] flex flex-col jusitfy-start items-center z-[50]" style={{ overflowY: 'auto' }}>
                        <div className="text-black text-[20px] font-[700]">統計分析</div>
                        <div className="text-black text-[16px] font-[400] mt-[16px] font-bold">學歷背景</div>
                        {['學士 Bachelor', '碩士 Master', '博士 Doctor', '其他 Other'].map(key =>
                            <div className="flex flex-row justify-between w-[90%] px-[16px]" key={key}>
                                <div>{key}</div>
                                <div>{((statisticsData['學歷背景'][key] || 0)/getTotal('學歷背景') * 100).toFixed(2)}%</div>
                            </div>
                        )}
                        {/*pie chart*/}
                        <div className="w-[90%] h-[600px] bg-[#eee]">
                            <Pie options={options}
                                data={{

                                    labels: ['學士 Bachelor', '碩士 Master', '博士 Doctor', '其他 Other'],
                                    datasets: [
                                        {
                                            label: '# of Votes',
                                            data: [statisticsData['學歷背景']['學士 Bachelor'] || 0, statisticsData['學歷背景']['碩士 Master'] || 0, statisticsData['學歷背景']['博士 Doctor'] || 0, statisticsData['學歷背景']['其他 Other'] || 0],
                                            backgroundColor: [
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(75, 192, 192, 1)',
                                            ],
                                            borderColor: [
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(75, 192, 192, 1)',
                                            ],
                                            borderWidth: 1,
                                        },
                                    ],
                                }}
                            />
                        </div>



                        <div className="text-black text-[16px] font-[400] mt-[16px] font-bold">工作經驗</div>
                        {['應屆畢業生 Fresh graduates',
                            '1-2年工作經驗 working experience',
                            '3-5年工作經驗 working experience',
                            '6-9年工作經驗 working experience',
                            '10年及以上工作經驗 working experience'].map(key =>
                                <div className="flex flex-row justify-between px-[16px] w-[90%]" key={key}>
                                    <div>{key}</div>
                                    <div>{((statisticsData['工作經驗'][key] || 0)/getTotal('工作經驗') * 100).toFixed(2)}%</div>
                                </div>
                            )}
                        {/*pie chart*/}
                        <div className="w-[90%] h-[600px] bg-[#eee]">
                            <Pie options={options}
                                data={{

                                    labels: ['應屆畢業生 Fresh graduates',
                                        '1-2年工作經驗 working experience',
                                        '3-5年工作經驗 working experience',
                                        '6-9年工作經驗 working experience',
                                        '10年及以上工作經驗 working experience'],
                                    datasets: [
                                        {
                                            label: '# of Votes',
                                            data: [statisticsData['工作經驗']['應屆畢業生 Fresh graduates'] || 0, statisticsData['工作經驗']['1-2年工作經驗 working experience'] || 0, statisticsData['工作經驗']['3-5年工作經驗 working experience'] || 0, statisticsData['工作經驗']['6-9年工作經驗 working experience'] || 0, statisticsData['工作經驗']['10年及以上工作經驗 working experience'] || 0],
                                            backgroundColor: [
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(75, 192, 192, 1)',
                                                'rgba(153, 102, 255, 1)',
                                            ],
                                            borderColor: [
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(75, 192, 192, 1)',
                                                'rgba(153, 102, 255, 1)',
                                            ],
                                            borderWidth: 1,
                                        },
                                    ],
                                }}
                            />
                        </div>

                        <div className="text-black text-[16px] font-[400] mt-[16px] font-bold">來港方式</div>
                        {['香港本地永久居民 Hong Kong Permanent Resident',
                            '優秀人才入境計劃 Quality Migrant AdmissionScheme',
                            '輸入內地人才計劃 Admission Scheme for Mainland Talents and Professionals',
                            '一般就業政策（外籍專才）General Employment Policy',
                            '高端人才通行證計劃 Top Talent Pass Scheme',
                            '科技人才入境計劃 Technology Talent Admission Scheme',
                            '在讀學生 Student Visa',
                            '非本地畢業生留港/回港計劃 IANG Visa',
                            '澳門居民 Macao Resident',
                            '內地居民 Mainland Resident',
                            '其他國家身份 Resident of other countries'].map(key =>
                                <div className="flex flex-row justify-between w-[90%] px-[16px]" key={key}>
                                    <div>{key}</div>
                                    <div>{((statisticsData['來港方式'][key] || 0) / getTotal('來港方式') * 100).toFixed(2)}%</div>
                                </div>
                            )}
                        {/*pie chart*/}
                        <div className="w-[90%] h-[600px] bg-[#eee]">
                            <Pie options={options}
                                data={{

                                    labels: ['香港本地永久居民 Hong Kong Permanent Resident',
                                        '優秀人才入境計劃 Quality Migrant AdmissionScheme',
                                        '輸入內地人才計劃 Admission Scheme for Mainland Talents and Professionals',
                                        '一般就業政策（外籍專才）General Employment Policy',
                                        '高端人才通行證計劃 Top Talent Pass Scheme',
                                        '科技人才入境計劃 Technology Talent Admission Scheme',
                                        '在讀學生 Student Visa',
                                        '非本地畢業生留港/回港計劃 IANG Visa',
                                        '澳門居民 Macao Resident',
                                        '內地居民 Mainland Resident',
                                        '其他國家身份 Resident of other countries'],
                                    datasets: [
                                        {
                                            label: '# of Votes',
                                            data: [
                                                statisticsData['來港方式']['香港本地永久居民 Hong Kong Permanent Resident'] || 0,
                                                statisticsData['來港方式']['優秀人才入境計劃 Quality Migrant AdmissionScheme'] || 0,
                                                statisticsData['來港方式']['輸入內地人才計劃 Admission Scheme for Mainland Talents and Professionals'] || 0,
                                                statisticsData['來港方式']['一般就業政策（外籍專才）General Employment Policy'] || 0,
                                                statisticsData['來港方式']['高端人才通行證計劃 Top Talent Pass Scheme'] || 0,
                                                statisticsData['來港方式']['科技人才入境計劃 Technology Talent Admission Scheme'] || 0,
                                                statisticsData['來港方式']['在讀學生 Student Visa'] || 0,
                                                statisticsData['來港方式']['非本地畢業生留港/回港計劃 IANG Visa'] || 0,
                                                statisticsData['來港方式']['澳門居民 Macao Resident'] || 0,
                                                statisticsData['來港方式']['內地居民 Mainland Resident'] || 0,
                                                statisticsData['來港方式']['其他國家身份 Resident of other countries'] || 0,
                                            ],
                                            backgroundColor: [
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(75, 192, 192, 1)',
                                                'rgba(153, 102, 255, 1)',
                                                'rgba(255, 159, 64, 1)',
                                                'rgba(199, 199, 199, 1)',
                                                'rgba(83, 102, 255, 1)',
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 135, 1)',
                                                'rgba(155, 106, 86, 1)',
                                            ],
                                            borderColor: [
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 235, 1)',
                                                'rgba(255, 206, 86, 1)',
                                                'rgba(75, 192, 192, 1)',
                                                'rgba(153, 102, 255, 1)',
                                                'rgba(255, 159, 64, 1)',
                                                'rgba(199, 199, 199, 1)',
                                                'rgba(83, 102, 255, 1)',
                                                'rgba(255, 99, 132, 1)',
                                                'rgba(54, 162, 135, 1)',
                                                'rgba(155, 106, 86, 1)',
                                            ],
                                            borderWidth: 1,
                                        },
                                    ],
                                }}
                            />
                        </div>

                        <div onClick={() => { setStatisticsData(null) }} className="w-[300px] p-[8px] text-center rounded-[99px] flex flex-row items-center justify-center text-[#0F737E] bg-[white] cursor-pointer mt-[24px]">
                            關閉
                        </div>
                    </div>
                </div>
            }

            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)




const ReloadSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={17}
        fill="none"
        {...props}
    >
        <path
            fill="#7A7A7A"
            d="M14.445 7.931a7.07 7.07 0 0 0-1.071-2.545 7.16 7.16 0 0 0-1.922-1.922 7.077 7.077 0 0 0-4-1.214V.667L4.31 3.039l3.144 2.373v-1.58a5.505 5.505 0 0 1 3.113.943 5.539 5.539 0 0 1 .82 8.507 5.557 5.557 0 0 1-2.797 1.508 5.641 5.641 0 0 1-2.231 0 5.538 5.538 0 0 1-4.42-5.424H.354c.001 1.418.425 2.804 1.218 3.98a7.192 7.192 0 0 0 1.92 1.92 7.078 7.078 0 0 0 3.98 1.217 7.128 7.128 0 0 0 5.902-3.139 7.08 7.08 0 0 0 1.215-3.978c0-.482-.049-.963-.145-1.435Z"
        />
    </svg>
)